import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

// =============================================================================
// LMDDC — icône Authentik (remplace le logo Google upstream).
//
// L'export par défaut DOIT rester nommé `GoogleIcon` : le composant
// google-button l'importe sous ce nom (`import GoogleIcon from '../google-icon'`).
// On ne change que le rendu, pas la signature.
//
// Icône par défaut = bouclier + serrure aux couleurs Authentik (#fd4b2d).
// Pour la marque exacte, remplacer le contenu <SvgIcon> par le logo officiel
// (assets de https://goauthentik.io).
// =============================================================================
const AuthentikIconSvg = () => {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        fill="#fd4b2d"
        d="M12 2 3 6v6c0 5 3.8 9.2 9 10 5.2-.8 9-5 9-10V6l-9-4z"
      />
      <path
        fill="#ffffff"
        d="M12 7a2.6 2.6 0 0 0-1.1 4.95V16h2.2v-4.05A2.6 2.6 0 0 0 12 7zm0 1.9a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8z"
      />
    </SvgIcon>
  );
};

const GoogleIcon = <AuthentikIconSvg />;

export default GoogleIcon;
